import React, { useContext, useEffect, useState } from 'react';
import { components } from 'react-select';
import { useTranslation } from 'react-i18next';
import { WelletContext } from '../../../context/WelletContext';
import SolidChevron from '../../icons/SolidChevron';
import GeneralSelectorPicker from '../../SelectorPicker/GeneralSelectorPicker';
import InputFormBorder from '../InputFormBorder/InputFormBorder';

const RPAndCitySelector = ({
  requiresRP,
  selectedRp,
  setSelectedRp,
  selectedCity,
  setSelectedCity,
  handleChange,
  errors,
  values,
}) => {
  const { t } = useTranslation();
  const welletContext = useContext(WelletContext);

  const [rps, setRps] = useState([]);

  const withoutRP = { value: '0', label: t('signUp.withOutRP') };

  const DropdownIndicator = (props) => (
    <components.DropdownIndicator {...props} className='mr-3 p-0'>
      <SolidChevron size={18} color='var(--color-primary)' />
    </components.DropdownIndicator>
  );

  const selectorStyles = {
    control: (provided) => ({
      ...provided,
      paddingLeft: '.4rem',
      boxShadow: 'none',
      backgroundColor: '#000',
      border: 'none',
      borderRadius: '10px',
      height: '61.38px',
    }),
    menu: (provided) => ({
      ...provided,
      bottom: 'auto',
      top: 65,
      color: '#000',
      zIndex: 9999,
    }),
  };

  const cityOptions = [
    { value: 935, label: 'Cancún' },
    { value: 2265, label: 'Ciudad de México' },
    { value: 7925, label: 'Isla Mujeres' },
    { value: 182189, label: 'Tulum' },
    { value: 9631, label: 'Los Cabos' },
  ];

  const getRP = async () => {
    try {
      const result = await welletContext.apis.tickets.get(`associates/GetRPs`);
      const formatted = result.data.map((item) => ({ value: item.id, label: item.name }));
      setRps([...formatted, withoutRP]);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    getRP();
  }, []);

  const handleChangeRP = (selectedOption) => {
    handleChange({ target: { name: 'rp', value: selectedOption.value }, persist: () => {} });
    setSelectedRp(selectedOption);
  };

  const handleChangeCity = (selectedOption) => {
    handleChange({ target: { name: 'city', value: selectedOption.value }, persist: () => {} });
    setSelectedCity(selectedOption);
  };

  return (
    <>
      <div className={`field-border-container mt-4 ${errors.city ? 'error' : ''}`}>
        <div className='field-none-border p-0'>
          <div className='field-border-name' style={{ zIndex: '4' }}>
            {t('signUp.cityOfOperation')}
          </div>
          <GeneralSelectorPicker
            className='w-100 mt-0 hide-indicator-separator font-normal'
            components={{ DropdownIndicator }}
            isSearchable={false}
            styles={selectorStyles}
            options={cityOptions}
            onChange={handleChangeCity}
            placeholder={selectedCity?.label}
            value={values.city}
            formatOptionLabel={(o) => (
              <div className='option-inner d-flex py-3'>
                <span>{o.label}</span>
              </div>
            )}
          />
        </div>
        {errors.city && <div className='errorLabel'>{errors.city}</div>}
      </div>
      <div className='mt-4'>
        <InputFormBorder
          name='hotelName'
          type='text'
          value={values.hotelName || ''}
          error={errors.hotelName}
          label={t('affiliateType.label.conciergeHotelName')}
          placeholder={t('affiliateType.placeholder.conciergeHotelName')}
          onChange={handleChange}
        />
      </div>

      {requiresRP && (
        <div className={`field-border-container mt-4 ${errors.rp ? 'error' : ''}`}>
          <div className='field-none-border p-0'>
            <div className='field-border-name' style={{ zIndex: '2' }}>
              {t('signUp.digitalRP')}
            </div>
            <GeneralSelectorPicker
              className='w-100 mt-0 hide-indicator-separator font-normal'
              components={{ DropdownIndicator }}
              isSearchable={false}
              styles={selectorStyles}
              options={rps}
              onChange={handleChangeRP}
              placeholder={selectedRp?.label}
              value={values.rp}
              formatOptionLabel={(o) => (
                <div className='option-inner d-flex py-3'>
                  <span>{o.label}</span>
                </div>
              )}
            />
          </div>
          {errors.rp && <div className='errorLabel'>{errors.rp}</div>}
        </div>
      )}
    </>
  );
};

export default RPAndCitySelector;
